module.exports = __webpack_public_path__ + "static/media/cx.fb1418e1.svg";